<script setup lang="ts">
import { useTabsStore } from '@/stores/useTabsStore';
import { helpcenterTabs } from '@/constants/tabs';

import tabsStyles from '@/styles/tabs.module.scss';

const tabsStore = useTabsStore();
</script>

<template>
  <div :class="[$style.smartHelpcenterSideBarTabs, tabsStyles.tabsWrapper]">
    <v-tabs
      v-model="tabsStore.tabs.helpcenter"
      :class="tabsStyles.tabs"
      grow
      :show-arrows="false"
    >
      <v-tab
        v-for="(tabValue, tabKey, tabIndex) in helpcenterTabs"
        :key="tabKey"
        :value="tabKey"
        :ripple="false"
        :class="tabsStyles.tab"
        variant="plain"
      >
        {{ tabValue }}
      </v-tab>
    </v-tabs>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.smartHelpcenterSideBarTabs {
  padding: 0 10px;
}
</style>
